export enum UserRole {
  Manager = 1,
  Assistant = 2,
  Provider = 3,
  SuperAdmin = 4,
}

/** i18n keys for role titles — use with t(): t(getRoleTitleKey(role)) */
export const ROLE_TITLE_KEYS: Record<UserRole, string> = {
  [UserRole.Manager]: "userManagement.roles.manager",
  [UserRole.Assistant]: "userManagement.roles.assistant",
  [UserRole.Provider]: "userManagement.roles.provider",
  [UserRole.SuperAdmin]: "userManagement.roles.superAdmin",
};

export function getRoleTitleKey(role: UserRole): string {
  return ROLE_TITLE_KEYS[role] ?? "userManagement.roles.provider";
}

/**
 * Hardcoded fallbacks kept for backward compatibility with existing code
 * that builds option arrays at module level (outside React components).
 * New code should use ROLE_TITLE_KEYS + t() instead.
 */
export const ROLE_TITLES: Record<UserRole, string> = {
  [UserRole.Manager]: "Manager",
  [UserRole.Assistant]: "Assistant",
  [UserRole.Provider]: "Provider",
  [UserRole.SuperAdmin]: "SuperAdmin",
};

export const ROLE_OPTIONS: Array<{ value: number; label: string }> = [
  { value: UserRole.Provider, label: ROLE_TITLES[UserRole.Provider] },
  { value: UserRole.Assistant, label: ROLE_TITLES[UserRole.Assistant] },
  { value: UserRole.Manager, label: ROLE_TITLES[UserRole.Manager] },
];

export const ROLE_FILTER_OPTIONS: Array<{
  value: UserRole | "";
  label: string;
}> = [
  { value: "", label: "All Roles" },
  { value: UserRole.Provider, label: ROLE_TITLES[UserRole.Provider] },
  { value: UserRole.Assistant, label: ROLE_TITLES[UserRole.Assistant] },
  { value: UserRole.Manager, label: ROLE_TITLES[UserRole.Manager] },
];

export const AUDIT_ROLE_FILTER_OPTIONS: Array<{
  value: string;
  label: string;
}> = [
  { value: "", label: "All Roles" },
  { value: "provider", label: ROLE_TITLES[UserRole.Provider] },
  { value: "assistant", label: ROLE_TITLES[UserRole.Assistant] },
  { value: "manager", label: ROLE_TITLES[UserRole.Manager] },
];
